import classnames from 'classnames';
import { RenderItemPropType } from 'ui-components/prop-types/tree-navigation';
import { emptyObject } from 'ui-components/default-props/empty';
import { TreeItemContent } from './tree-item-content';
import style from 'ui-components/components/tree-navigation/tree-navigation.module.less';

export const TreeItem = ({ item = emptyObject, isHighlighted, onItemSelected, buildTagProps, onExpandClick, treeItemClassName }) => {
  const { id, items: subItems, expanded, selected } = item;

  const classes = classnames(
    style['tree-navigation-item'],
    {
      [style.expanded]: expanded,
      [style['is-selected-item']]: selected,
    },
    treeItemClassName,
  );

  return (
    <div key={id} className={classes} data-testid={id} tabIndex={-1}>
      <TreeItemContent
        buildTagProps={buildTagProps}
        isHighlighted={isHighlighted}
        item={item}
        onExpandClick={onExpandClick}
        onItemSelected={onItemSelected}
        shouldRenderAnIcon={item.shouldRenderAnIcon}
        tabIndex={0}
      />
      <div
        className={classnames(style['tree-navigation-subitems'], {
          [style['hidden-subitems']]: !(subItems && expanded),
        })}
        data-testid='tree-item-subitems'
        role='group'
      >
        {!subItems
          ? null
          : subItems.map((subItem, subItemIndex) => (
              <TreeItemContent
                key={subItem.id}
                buildTagProps={buildTagProps}
                isHighlighted={isHighlighted}
                item={subItem}
                onItemSelected={onItemSelected}
                shouldRenderAnIcon={subItem.shouldRenderAnIcon}
                subItemIndex={subItemIndex}
                tabIndex={expanded ? 0 : -1}
              />
            ))}
      </div>
    </div>
  );
};

TreeItem.propTypes = RenderItemPropType;
